/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface JpClassSectionLookupBase
 */
export interface JpClassSectionLookupBaseOptional {
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupBase
   */
  sectionName?: string;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupBase
   */
  displayOrder?: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupBase
   */
  svgUrl?: string;
}

export interface JpClassSectionLookupBase extends JpClassSectionLookupBaseOptional {
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupBase
   */
  sectionName?: string;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupBase
   */
  displayOrder?: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupBase
   */
  svgUrl?: string;
}

export interface JpClassSectionLookupBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupBase
   */
  sectionName?: string;
  sectionNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupBase
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupBase
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupBase
   */
  svgUrl?: string;
  svgUrlIsSet: boolean;
}

transformDatesMap.set(
  "JpClassSectionLookupBase",
  function (model: JpClassSectionLookupBase) {},
);

export type JpClassSectionLookupBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  sectionName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  svgUrl: PropertyMeta<MetaTypeBase<string>>;
}>;

export var JpClassSectionLookupBaseMeta: JpClassSectionLookupBaseMetaI =
  {} as JpClassSectionLookupBaseMetaI;
JpClassSectionLookupBaseMeta = typeMeta("JpClassSectionLookupBase", {
  sectionName: propertyMeta(
    "sectionName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  svgUrl: propertyMeta("svgUrl", false, false, false, MetaTypesBase.string),
});

const metaI = JpClassSectionLookupBaseMeta;

registerMeta(() => {});

export class JpClassSectionLookupBaseTracked implements JpClassSectionLookupBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  sectionName__I?: string = undefined;
  sectionNameIsSet: boolean = false;
  set sectionName(v: undefined | string) {
    if (v !== undefined) {
      this.sectionName__I = v;
      this.sectionNameIsSet = true;
    } else {
      this.sectionName__I = v || undefined;
      this.sectionNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get sectionName() {
    return this.sectionName__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  svgUrl__I?: string = undefined;
  svgUrlIsSet: boolean = false;
  set svgUrl(v: undefined | string) {
    if (v !== undefined) {
      this.svgUrl__I = v;
      this.svgUrlIsSet = true;
    } else {
      this.svgUrl__I = v || undefined;
      this.svgUrlIsSet = false;
    }
    this.changeTracker = true;
  }
  get svgUrl() {
    return this.svgUrl__I;
  }
  constructor(
    config?: JpClassSectionLookupBaseOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: JpClassSectionLookupBaseOptional,
    options?: AssignOptions,
  ): JpClassSectionLookupBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.sectionName &&
      this.sectionNameApplyFilter(optionsRequired.filter)
    ) {
      this.sectionName = config.sectionName;
      if (optionsRequired.unassign) this.sectionNameIsSet = false;
      else this.sectionNameIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.svgUrl && this.svgUrlApplyFilter(optionsRequired.filter)) {
      this.svgUrl = config.svgUrl;
      if (optionsRequired.unassign) this.svgUrlIsSet = false;
      else this.svgUrlIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): JpClassSectionLookupBaseTrackedI {
    const cloned = {} as JpClassSectionLookupBaseTrackedI;
    if (
      this.sectionNameIsSetDeep() &&
      this.sectionNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sectionNameIsSet = true;
      cloned.sectionName = this.sectionName;
    } else {
      //cloned.sectionNameIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.svgUrlIsSetDeep() &&
      this.svgUrlApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.svgUrlIsSet = true;
      cloned.svgUrl = this.svgUrl;
    } else {
      //cloned.svgUrlIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): JpClassSectionLookupBaseTrackedI {
    if (!this.sectionNameApplyFilter(filter)) this.sectionNameIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.svgUrlApplyFilter(filter)) this.svgUrlIsSet = false;

    return this;
  }
  sectionNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupBaseMeta.sectionName,
      JpClassSectionLookupBaseMeta,
      this.sectionName,
      this,
    );
  }
  sectionNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sectionNameIsSet && this.sectionNameApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupBaseMeta.active,
      JpClassSectionLookupBaseMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupBaseMeta.displayOrder,
      JpClassSectionLookupBaseMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  svgUrlApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupBaseMeta.svgUrl,
      JpClassSectionLookupBaseMeta,
      this.svgUrl,
      this,
    );
  }
  svgUrlIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.svgUrlIsSet && this.svgUrlApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.sectionNameIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.svgUrlIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
